document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const cardLink = event.target.closest('[data-product-card-link]');
    if (cardLink) {
      sessionStorage.setItem('collectionScrollPosition', window.scrollY);
    }
  });

  const loadMoreText = window.translations?.load_more || 'Load More';
  const allText = window.translations?.all || 'All';
  const productsLoadedText = window.translations?.products_loaded || 'products loaded';
  const tryAgainText = window.translations?.try_again || 'Try again';
  const loadingText = window.translations?.loading || 'Loading...';

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const scrollPosition = sessionStorage.getItem('collectionScrollPosition');
  const loadedPage = sessionStorage.getItem('loadedPage');
  const collectionUrl = window.location.pathname;
  const savedCollectionUrl = sessionStorage.getItem('collectionUrl');

  let isLoading = false;
  const loadMoreButton = document.getElementById('load-more-button');
  let shouldRestoreScroll = false;
  let restoreScrollPosition = 0;

  const isNarrowViewport = () => window.matchMedia('(max-width: 989px)').matches;
  let restoringDesktop = false;

  function pageFromUrl() {
    const page = parseInt(new URL(window.location.href).searchParams.get('page'), 10);
    return Number.isFinite(page) && page > 1 ? page : 1;
  }

  function filterQueryString() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    return params.toString();
  }

  function urlWithPage(page) {
    const url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return url.pathname + url.search + url.hash;
  }

  function sectionFetchUrl(button, page) {
    const fetchUrl = new URL(button.getAttribute('data-url'), window.location.origin);
    new URL(window.location.href).searchParams.forEach((value, key) => {
      if (key !== 'page' && key !== 'section_id') {
        fetchUrl.searchParams.append(key, value);
      }
    });
    fetchUrl.searchParams.set('page', String(page));
    fetchUrl.searchParams.set('section_id', button.getAttribute('data-section-id'));
    return fetchUrl.pathname + fetchUrl.search;
  }

  function currentGridPage() {
    const current = document.querySelector('.collection-page-num.is-current');
    const page = parseInt(current?.getAttribute('data-page'), 10);
    return Number.isFinite(page) && page > 0 ? page : 1;
  }

  function syncHistory(page) {
    const searchParams = filterQueryString();
    // Page changes keep the same filter string. Match what facets already stored
    // so its popstate handler does not fetch a second copy of the grid.
    if (window.FacetFiltersForm) {
      window.FacetFiltersForm.searchParamsPrev = searchParams;
    }
    history.pushState(
      { collectionPage: page, searchParams },
      '',
      urlWithPage(page)
    );
  }

  function initButton(button, { fillDesktop = true } = {}) {
    if (!button || button.dataset.init) return;
    button.dataset.init = 'true';
    button.addEventListener('click', handleLoadMore);
    syncMobilePager(pageFromUrl(), parseInt(button.getAttribute('data-total-pages'), 10));
    if (fillDesktop) fillDesktopFirstPage(button);
  }

  if (loadMoreButton) {
    sessionStorage.setItem('collectionUrl', collectionUrl);
    const newButton = loadMoreButton.cloneNode(true);
    loadMoreButton.parentNode.replaceChild(newButton, loadMoreButton);

    if (scrollPosition && loadedPage && collectionUrl === savedCollectionUrl) {
      if (isNarrowViewport()) {
        sessionStorage.removeItem('loadedPage');
        sessionStorage.removeItem('collectionScrollPosition');
      } else {
        restoringDesktop = true;
        restoreScrollPosition = parseInt(scrollPosition);
        shouldRestoreScroll = true;

        const currentPage = parseInt(newButton.getAttribute('data-next-page'));
        const targetPage = parseInt(loadedPage);

        if (currentPage <= targetPage) {
          const loadPages = async () => {
            for (let i = currentPage; i <= targetPage; i++) {
              await loadPage(i, newButton, false);
            }
            restoreScroll();
          };

          loadPages();
        } else {
          restoreScroll();
        }
      }
    }

    initButton(newButton, { fillDesktop: !restoringDesktop });
  }

  function restoreScroll() {
    if (shouldRestoreScroll && restoreScrollPosition > 0) {
      window.scrollTo(0, restoreScrollPosition);
      shouldRestoreScroll = false;

      sessionStorage.removeItem('collectionScrollPosition');
    }
  }

  function scrollGridIntoView(productGrid) {
    const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const top = productGrid.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo(0, Math.max(0, top));
  }

  async function fillDesktopFirstPage(button) {
    if (isNarrowViewport()) return;

    const desktopSize = parseInt(button.getAttribute('data-desktop-page-size'), 10);
    if (!desktopSize) return;

    await appendUntilCount(button, desktopSize);
  }

  function writeProductCount(button, loadedCount) {
    const productCountElement = document.getElementById('product-count');
    if (!productCountElement) return;

    const totalProducts = parseInt(button.getAttribute('data-total-products'), 10);
    const pageSize = parseInt(button.getAttribute('data-page-size'), 10) || 1;
    const firstPage = parseInt(button.getAttribute('data-first-page'), 10) || 1;
    const start = (firstPage - 1) * pageSize + 1;
    const end = Math.min(start + Math.max(loadedCount, 1) - 1, totalProducts);

    if (firstPage <= 1 && loadedCount >= totalProducts) {
      productCountElement.textContent = `${allText} ${totalProducts} ${productsLoadedText}`;
      return;
    }

    productCountElement.textContent = `${start}–${end} of ${totalProducts} products`;
  }

  async function appendUntilCount(button, targetCount) {
    const totalPages = parseInt(button.getAttribute('data-total-pages'), 10);
    const totalProducts = parseInt(button.getAttribute('data-total-products'), 10);
    const pageSize = parseInt(button.getAttribute('data-page-size'), 10) || 1;
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const loaded = productGrid.querySelectorAll('li.grid__item:not(.grid__item--content)').length;
    const startPage = parseInt(button.getAttribute('data-next-page'), 10);
    if (loaded >= targetCount || startPage > totalPages) return;

    const pagesNeeded = Math.ceil((targetCount - loaded) / pageSize);
    const pages = [];
    for (let page = startPage; page < startPage + pagesNeeded && page <= totalPages; page += 1) {
      pages.push(page);
    }
    if (!pages.length) return;

    const label = button.innerHTML;
    button.disabled = true;
    button.innerHTML = loadingText;
    isLoading = true;

    try {
      const results = await Promise.all(pages.map(async (page) => {
        const response = await fetch(sectionFetchUrl(button, page));
        if (!response.ok) throw new Error('Page request failed');
        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return [...tempDiv.querySelectorAll('#product-grid > li.grid__item')];
      }));

      results.forEach((items) => {
        items.forEach((item) => productGrid.appendChild(item));
      });

      const lastPage = pages[pages.length - 1];
      button.setAttribute('data-next-page', String(lastPage + 1));

      const newLoadedCount = productGrid.querySelectorAll('li.grid__item:not(.grid__item--content)').length;
      const firstPage = parseInt(button.getAttribute('data-first-page'), 10) || 1;
      const finished = lastPage + 1 > totalPages || (firstPage <= 1 && newLoadedCount >= totalProducts);
      writeProductCount(button, newLoadedCount);
      button.style.display = finished ? 'none' : '';
      document.dispatchEvent(new CustomEvent('load-more-done'));
      button.innerHTML = label;
      button.disabled = false;
    } catch (error) {
      button.innerHTML = tryAgainText;
      button.disabled = false;
    } finally {
      isLoading = false;
    }
  }

  async function loadPage(page, button, replaceGrid, updateUrl) {
    if (isLoading) return Promise.resolve();

    return new Promise((resolve) => {
      isLoading = true;
      const totalPages = parseInt(button.getAttribute('data-total-pages'));
      const totalProducts = parseInt(button.getAttribute('data-total-products'));

      fetch(sectionFetchUrl(button, page))
        .then(response => {
          if (!response.ok) throw new Error('Page request failed');
          return response.text();
        })
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const newItems = tempDiv.querySelectorAll('#product-grid > li.grid__item');
          const productGrid = document.getElementById('product-grid');

          if (replaceGrid && !newItems.length) throw new Error('Page response had no products');

          if (replaceGrid) {
            productGrid.querySelectorAll(':scope > li.grid__item').forEach((item) => item.remove());
          }

          newItems.forEach(item => {
            productGrid.appendChild(item);
          });

          const newLoadedCount = productGrid.querySelectorAll('li.grid__item:not(.grid__item--content)').length;

          const newNextPage = page + 1;
          button.setAttribute('data-next-page', newNextPage);
          if (replaceGrid) button.setAttribute('data-first-page', String(page));
          writeProductCount(button, newLoadedCount);

          if (replaceGrid) {
            syncMobilePager(page, totalPages);
          } else if (newNextPage > totalPages || newLoadedCount >= totalProducts) {
            button.style.display = 'none';
            if (newLoadedCount >= totalProducts) writeProductCount(button, newLoadedCount);
          } else {
            button.style.display = '';
          }

          if (replaceGrid) {
            scrollGridIntoView(productGrid);
            if (updateUrl) syncHistory(page);
            productGrid.setAttribute('tabindex', '-1');
            productGrid.focus({ preventScroll: true });
          }

          isLoading = false;
          resolve();

          document.dispatchEvent(new CustomEvent('load-more-done'));
        })
        .catch(error => {
          if (replaceGrid) {
            syncMobilePager(pageFromUrl(), totalPages);
          } else {
            button.innerHTML = tryAgainText;
            button.disabled = false;
          }
          isLoading = false;
          resolve();
        });
    });
  }

  async function handleLoadMore() {
    if (isLoading) return;

    const button = this;
    const totalPages = parseInt(button.getAttribute('data-total-pages'));
    sessionStorage.setItem('collectionUrl', window.location.pathname);

    if (isNarrowViewport()) return;

    {
      const desktopSize = parseInt(button.getAttribute('data-desktop-page-size'), 10);
      const productGrid = document.getElementById('product-grid');
      const startCount = productGrid
        ? productGrid.querySelectorAll('li.grid__item:not(.grid__item--content)').length
        : 0;
      const targetCount = startCount + (desktopSize || 0);

      await appendUntilCount(button, targetCount || startCount + 1);

      const lastLoadedPage = parseInt(button.getAttribute('data-next-page'), 10) - 1;
      if (lastLoadedPage > 0) {
        sessionStorage.setItem('loadedPage', lastLoadedPage);
      }
    }

    button.innerHTML = loadMoreText;
    button.disabled = false;

    if (parseInt(button.getAttribute('data-next-page'), 10) > totalPages) {
      sessionStorage.removeItem('loadedPage');
    }
  }
  function pageWindow(current, total) {
    const pages = new Set();
    if (current <= 3) {
      pages.add(1);
      pages.add(2);
      pages.add(3);
      pages.add(total);
    } else if (current >= total - 2) {
      pages.add(1);
      pages.add(total - 2);
      pages.add(total - 1);
      pages.add(total);
    } else {
      pages.add(1);
      pages.add(current);
      pages.add(total);
    }

    const sorted = [...pages].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
    const items = [];
    let previous = 0;
    sorted.forEach((n) => {
      if (previous && n - previous > 1) items.push('…');
      items.push(n);
      previous = n;
    });
    return items;
  }

  function pagerArrow(direction, targetPage, disabled) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-page-arrow';
    button.dataset.page = String(targetPage);
    button.disabled = disabled;
    button.setAttribute('aria-label', direction === 'prev' ? 'Previous page' : 'Next page');
    const path = direction === 'prev' ? 'M7 1L1 7L7 13' : 'M1 1L7 7L1 13';
    button.innerHTML = `<svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="${path}" stroke="currentColor" stroke-width="1.2"/></svg>`;
    return button;
  }

  function syncMobilePager(page, totalPages) {
    const nav = document.querySelector('.collection-page-nav');
    if (!nav || !totalPages) return;

    nav.replaceChildren();
    nav.appendChild(pagerArrow('prev', page - 1, page <= 1));
    pageWindow(page, totalPages).forEach((item) => {
      if (item === '…') {
        const ellipsis = document.createElement('span');
        ellipsis.className = 'collection-page-ellipsis';
        ellipsis.setAttribute('aria-hidden', 'true');
        ellipsis.textContent = '…';
        nav.appendChild(ellipsis);
        return;
      }

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'collection-page-num';
      button.dataset.page = String(item);
      button.textContent = String(item);
      if (item === page) {
        button.classList.add('is-current');
        button.setAttribute('aria-current', 'page');
        button.disabled = true;
      }
      nav.appendChild(button);
    });
    nav.appendChild(pagerArrow('next', page + 1, page >= totalPages));
  }

  document.addEventListener('click', function(event) {
    const pageBtn = event.target.closest('.collection-page-num, .collection-page-arrow');
    if (!pageBtn || pageBtn.disabled || isLoading || !isNarrowViewport()) return;

    const button = document.getElementById('load-more-button');
    if (!button) return;

    const totalPages = parseInt(button.getAttribute('data-total-pages'), 10);
    const page = parseInt(pageBtn.getAttribute('data-page'), 10);
    if (!Number.isFinite(page) || page < 1 || page > totalPages || page === pageFromUrl()) return;

    sessionStorage.setItem('collectionUrl', window.location.pathname);
    loadPage(page, button, true, true);
  });

  const observer = new MutationObserver(() => {
    const btn = document.getElementById('load-more-button');
    if (btn && !btn.dataset.init) initButton(btn);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('popstate', (event) => {
    if (!isNarrowViewport()) return;

    const button = document.getElementById('load-more-button');
    if (!button) return;

    const urlPage = pageFromUrl();
    if (urlPage === currentGridPage()) return;

    const facetFilters = window.FacetFiltersForm;
    if (facetFilters) {
      const searchParams = event.state ? event.state.searchParams : facetFilters.searchParamsInitial;
      if (searchParams !== facetFilters.searchParamsPrev) return;
    }

    loadPage(urlPage, button, true, false);
  });
});
